import moment from 'moment'
import { Api, Config } from './api'

export const ApiObterUsuDelegacaoHist = async (filtros) => {
   const formatData = 'YYYY-MM-DD'

   const params = new URLSearchParams()

   if (filtros.pagina) {
      params.append('pagina', filtros.pagina)
   }

   if (filtros.limite) {
      params.append('limite', filtros.limite)
   }
   if (filtros.delegadorNome) {
      params.append('delegadorNome', filtros.delegadorNome)
   }
   if (filtros.delegadoNome) {
      params.append('delegadoNome', filtros.delegadoNome)
   }
   if (filtros.perfilSap) {
      params.append('perfilSap', filtros.perfilSap)
   }

   if (filtros.dataInicio) {
      let dataFiltro

      if (filtros.dataInicio.length > 1) {
         dataFiltro = `${moment(filtros.dataInicio[0]).format(formatData)},${moment(filtros.dataInicio[1]).format(formatData)}`
      } else {
         dataFiltro = moment(filtros.dataInicio).format(formatData)
      }
      params.append('dataInicio', dataFiltro)
   }
   if (filtros.dataFim) {
      let dataFiltro

      if (filtros.dataFim.length > 1) {
         dataFiltro = `${moment(filtros.dataFim[0]).format(formatData)},${moment(filtros.dataFim[1]).format(formatData)}`
      } else {
         dataFiltro = moment(filtros.dataFim).format(formatData)
      }

      params.append('dataFim', dataFiltro)
   }

   const { data } = await Api.get(`/delegacoes-equipe`, Config(params))

   return data
}

export const ApiGerarRelatorioUsuDelegacao = async (filtros) => {
   const formatData = 'YYYY-MM-DD'
   const payload = {}

   if (filtros.pagina) {
      payload.pagina = filtros.pagina
   }

   if (filtros.limite) {
      payload.limite = filtros.limite
   }
   if (filtros.delegadorNome) {
      payload.delegadorNome = filtros.delegadorNome
   }
   if (filtros.delegadoNome) {
      payload.delegadoNome = filtros.delegadoNome
   }
   if (filtros.perfilSap) {
      payload.perfilSap = filtros.perfilSap
   }

   if (filtros.dataInicio) {
      let dataFiltro

      if (filtros.dataInicio.length > 1) {
         dataFiltro = `${moment(filtros.dataInicio[0]).format(formatData)},${moment(filtros.dataInicio[1]).format(formatData)}`
      } else {
         dataFiltro = moment(filtros.dataInicio).format(formatData)
      }
      payload.dataInicio = dataFiltro
   }
   if (filtros.dataFim) {
      let dataFiltro

      if (filtros.dataFim.length > 1) {
         dataFiltro = `${moment(filtros.dataFim[0]).format(formatData)},${moment(filtros.dataFim[1]).format(formatData)}`
      } else {
         dataFiltro = moment(filtros.dataFim).format(formatData)
      }

      payload.dataFim = dataFiltro
   }

   const { data } = await Api.post(`/relatorios/historico-delegacoes-equipe`, payload, Config())

   return data
}
